/**
 * Only Cookies USA — Build Your Box: Cookie Tray Picker
 *
 * UX: Single flavor palette at top → click a flavor → fills the next empty
 * tray slot. Each slot can be cleared individually. Hidden inputs carry
 * line item properties for Shopify cart.
 *
 * Translations are passed via data-t-* attributes on the .oc-picker element
 * (rendered server-side by Liquid using Shopify's | t filter).
 */
(function () {
  var picker = document.querySelector('.oc-picker');
  if (!picker) return;

  var cookieCount = parseInt(picker.dataset.cookieCount, 10) || 4;
  var slots = [];
  var flavorButtons = picker.querySelectorAll('.oc-picker__flavor');
  var countDisplay = picker.querySelector('[data-selected-count]');
  var progressBar = picker.querySelector('[data-progress-bar]');
  var hint = picker.querySelector('[data-picker-hint]');

  // Read translated strings from data attributes
  var t = {
    hintStart: picker.dataset.tHintStart || '',
    hintRemainingOne: picker.dataset.tHintRemainingOne || '',
    hintRemainingOther: picker.dataset.tHintRemainingOther || '',
    hintComplete: picker.dataset.tHintComplete || ''
  };

  var productInfo = picker.closest('.product__info-container') || picker.closest('section');
  var submitBtn = productInfo
    ? productInfo.querySelector('.product-form__submit')
    : document.querySelector('.product-form__submit');

  // Build slot references
  for (var i = 1; i <= cookieCount; i++) {
    var el = picker.querySelector('[data-tray-slot="' + i + '"]');
    if (el) {
      slots.push({
        el: el,
        input: el.querySelector('[data-slot-input]'),
        label: el.querySelector('[data-slot-label]'),
        clearBtn: el.querySelector('[data-slot-clear]'),
        index: i,
        flavor: ''
      });
    }
  }

  // --- State helpers ---

  function getFilledCount() {
    var n = 0;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].flavor) n++;
    }
    return n;
  }

  function getNextEmptySlot() {
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i].flavor) return slots[i];
    }
    return null;
  }

  function updateUI() {
    var filled = getFilledCount();

    // Counter
    if (countDisplay) countDisplay.textContent = filled;

    // Progress bar
    if (progressBar) {
      progressBar.style.width = (filled / cookieCount) * 100 + '%';
    }

    // Completion state
    var complete = filled === cookieCount;
    picker.classList.toggle('oc-picker--complete', complete);

    // Hint text (using translated strings)
    if (hint) {
      if (complete) {
        hint.textContent = t.hintComplete;
        hint.classList.add('oc-picker__hint--done');
      } else if (filled === 0) {
        hint.textContent = t.hintStart;
        hint.classList.remove('oc-picker__hint--done');
      } else {
        var remaining = cookieCount - filled;
        var msg = remaining === 1
          ? t.hintRemainingOne
          : t.hintRemainingOther.replace('__COUNT__', remaining);
        hint.textContent = msg;
        hint.classList.remove('oc-picker__hint--done');
      }
    }

    // Submit button
    if (submitBtn) {
      if (complete) {
        submitBtn.removeAttribute('disabled');
      } else {
        submitBtn.setAttribute('disabled', 'disabled');
      }
    }

    // Update flavor button states (show count badges)
    updateFlavorCounts();
  }

  function updateFlavorCounts() {
    // Count how many times each flavor is used
    var counts = {};
    for (var i = 0; i < slots.length; i++) {
      var f = slots[i].flavor;
      if (f) counts[f] = (counts[f] || 0) + 1;
    }

    flavorButtons.forEach(function (btn) {
      var flavor = btn.dataset.flavor;
      var count = counts[flavor] || 0;
      btn.classList.toggle('oc-picker__flavor--active', count > 0);
      // Update or create count badge
      var badge = btn.querySelector('.oc-picker__flavor-count');
      if (count > 1) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'oc-picker__flavor-count';
          btn.appendChild(badge);
        }
        badge.textContent = count + 'x';
      } else if (badge) {
        badge.remove();
      }
    });
  }

  // --- Slot operations ---

  function fillSlot(slot, flavor) {
    slot.flavor = flavor;
    slot.input.value = flavor;
    slot.label.textContent = flavor;
    slot.el.classList.add('oc-picker__slot--filled');
    // Trigger fill animation
    slot.el.classList.remove('oc-picker__slot--pop');
    void slot.el.offsetWidth; // reflow
    slot.el.classList.add('oc-picker__slot--pop');
    updateUI();
  }

  function clearSlot(slot) {
    slot.flavor = '';
    slot.input.value = '';
    slot.label.textContent = '';
    slot.el.classList.remove('oc-picker__slot--filled', 'oc-picker__slot--pop');
    updateUI();
  }

  // --- Event listeners ---

  // Flavor palette: click to fill next empty slot
  flavorButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nextSlot = getNextEmptySlot();
      if (!nextSlot) return; // Box is full
      fillSlot(nextSlot, btn.dataset.flavor);
    });
  });

  // Slot clear buttons
  slots.forEach(function (slot) {
    slot.clearBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      clearSlot(slot);
    });
  });

  // Clicking a filled slot clears it
  slots.forEach(function (slot) {
    slot.el.addEventListener('click', function (e) {
      if (e.target.closest('[data-slot-clear]')) return;
      if (slot.flavor) {
        clearSlot(slot);
      }
    });
  });

  // Initial state
  updateUI();
})();
